import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.math.sign.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.split.js";
import jwtDecode from 'jwt-decode';
import LOGS from '~/const/errorsLog';
import USE_MERCURE from '~/const/mercure';
import { calculateDifferenceInMinutes } from '~/helpers/refresh-auth-helper';
import { refreshToken, updateUserToken } from '~/services/user';
var parseHash = function parseHash(hash) {
  return hash.split('&').reduce(function (acc, item) {
    var currentAcc = acc;
    var parts = item.split('=');
    var _parts = _slicedToArray(parts, 2);
    currentAcc[parts[0]] = _parts[1];
    return currentAcc;
  }, {});
};
var isTokenAudienceSTS = function isTokenAudienceSTS(decodedToken) {
  var aud = decodedToken.aud;
  return Array.isArray(aud) && aud.includes('sts');
};
var shouldRefreshToken = function shouldRefreshToken(locale) {
  return window.localStorage.getItem('MDM_ACCESS_TOKEN') && USE_MERCURE(locale.iso);
};
var getTokenState = function getTokenState() {
  var decodedToken = jwtDecode(window.localStorage.getItem('MDM_ACCESS_TOKEN'));
  var tokenExpiresAt = Number(decodedToken.exp * 1000);
  var currentTimestamp = new Date().getTime();
  var differenceInMinute = calculateDifferenceInMinutes(tokenExpiresAt, currentTimestamp);
  var minutesBeforeExpiry = Math.sign(differenceInMinute) === 1 ? differenceInMinute : 0;
  var minutesExpiryThreshold = 5;
  return {
    forceRefresh: Boolean(window.localStorage.getItem('forceRefreshToken')),
    alreadyExpired: minutesBeforeExpiry === 0,
    almostExpired: minutesBeforeExpiry <= minutesExpiryThreshold,
    isAudienceSTS: isTokenAudienceSTS(decodedToken)
  };
};
var doRefreshToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(app, alreadyExpired, forceRefresh, isAudienceSTS) {
    var token, _data$refreshToken$to, _data$refreshToken, data, _data$updateUserToken, _data$updateUserToken2, _data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!isAudienceSTS) {
            _context.next = 8;
            break;
          }
          _context.next = 4;
          return refreshToken({
            app: app
          });
        case 4:
          data = _context.sent;
          token = (_data$refreshToken$to = data === null || data === void 0 ? void 0 : (_data$refreshToken = data.refreshToken) === null || _data$refreshToken === void 0 ? void 0 : _data$refreshToken.token) !== null && _data$refreshToken$to !== void 0 ? _data$refreshToken$to : null;
          _context.next = 12;
          break;
        case 8:
          _context.next = 10;
          return updateUserToken({
            app: app
          });
        case 10:
          _data = _context.sent;
          token = (_data$updateUserToken = _data === null || _data === void 0 ? void 0 : (_data$updateUserToken2 = _data.updateUserToken) === null || _data$updateUserToken2 === void 0 ? void 0 : _data$updateUserToken2.token) !== null && _data$updateUserToken !== void 0 ? _data$updateUserToken : null;
        case 12:
          if (token) {
            _context.next = 14;
            break;
          }
          throw new Error("MDM_REFRESH_TOKEN_EMPTY STS");
        case 14:
          if (forceRefresh) window.localStorage.removeItem('forceRefreshToken');
          window.localStorage.setItem('MDM_ACCESS_TOKEN', token);
          _context.next = 22;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](0);
          app.$logger.customFilter(_context.t0, "".concat(LOGS.MDM_REFRESH_TOKEN, " ").concat(isAudienceSTS ? 'STS' : 'MERCURE'));
          if (alreadyExpired) {
            window.localStorage.removeItem('MDM_ACCESS_TOKEN');
          }
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 18]]);
  }));
  return function doRefreshToken(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export var refreshTokenIfNecessary = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
    var app, store, _getTokenState, alreadyExpired, almostExpired, isAudienceSTS, forceRefresh;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          app = _ref2.app, store = _ref2.store;
          if (shouldRefreshToken(store.getters['i18n/locale'])) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          _getTokenState = getTokenState(), alreadyExpired = _getTokenState.alreadyExpired, almostExpired = _getTokenState.almostExpired, isAudienceSTS = _getTokenState.isAudienceSTS, forceRefresh = _getTokenState.forceRefresh;
          if (!(!forceRefresh && !alreadyExpired && !almostExpired)) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          _context2.next = 8;
          return doRefreshToken(app, alreadyExpired, forceRefresh, isAudienceSTS);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function refreshTokenIfNecessary(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
export default parseHash;